<script>
import {defineComponent} from 'vue'

import headNav from '../../src/components/headNav.vue'
import {
  mapGetters
} from "vuex";
import {phoneCountryList} from "../api/api";
export default {
  name: "home",
  components:{headNav},
  computed:{
    ...mapGetters(['userInfo'])
  },
  data(){
    return{
      numberText:'',
      arr:[
        '11111','222222','33333'
      ],
      pathText:'6666666',
      total:null,
      page:1,
      listArr:[],
    }
  },
  created() {

  },
  mounted() {
    this.getList()
  },
  methods:{
    getList(){
      phoneCountryList({
      }).then(res => {
        console.log(res,'打印res')
        // this.total = res.data.data.total
        this.listArr = res.data.data
      })
    },
    getMapping(list,num) {
      let len = list.length
      let newList = []
      if (len) {
        var chunk = num
        for (var i = 0, j = len; i < j; i += chunk) {
          newList.push(list.slice(i, i + chunk))
        }
      }
      console.log(newList,'打印分组后的数组')
      return newList
    },
    onCopy() {
      this.$copyText(this.pathText).then(
        e=>{
          console.log('复制成功：', e);
          this.$message({
            message: 'copied',
            type:'success'
          });
        },
        e=>{
          console.log('复制失败：', e);
        }
      )
    },
    pageChange(e){
      console.log(e)
      this.page = e
      this.getList()
    },
  }

}
</script>

<template>
  <div>
<!--    <head-nav></head-nav>-->
    <b-container class="ok" fluid style="margin-bottom: 30px;margin-top: 30px">
      <b-row>
        <b-col v-for="(item,index) in listArr" :key="index">
          <div class="module1" >
            <div class="headModule1">
              <img :src="item.image" style="width: 40px;height: 30px" alt="">
              <div style="font-size: 22px;display: inline-block">{{item.name}}</div>
            </div>
            <div style="width: 82px;height: 48px;margin: 10px auto">
              <button type="button" class="btn btn-outline-dark  btn-lg">Open</button>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
<!--    <b-container>-->
<!--      <b-row style="margin-bottom: 20px;margin-bottom: 15px">-->
<!--        <b-col sm="4" offset-sm="4">-->
<!--          <div class="">-->
<!--            <el-pagination-->
<!--              background-->
<!--              :page-size='12'-->
<!--              layout="prev, pager, next"-->
<!--              @current-change="pageChange"-->
<!--              :total="total">-->
<!--            </el-pagination>-->
<!--          </div>-->
<!--        </b-col>-->
<!--      </b-row>-->
<!--    </b-container>-->
  </div>
</template>

<style scoped>
@media screen and (min-width: 900px) {
  .ok>.row{
    margin-left: 200px;
    margin-right: 200px;
  }
}
.leftMesBox{
  box-shadow: 0 0.5em 1em -0.125em #0a0a0a1a, 0 0 0 1px #0a0a0a05;
  padding: 20px;
  box-sizing: border-box;
}
.mesModule{
  border-bottom: 1px solid #cccccc;
  padding: 10px 20px;
  box-sizing: border-box;
}
.mesModuleText1{
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 10px;
}
.mesModuleText2{

}

.onlineModule1{
  border-radius: 5px;
  background-color: #48C78E;
  color: #FFFFFF;
  width: 60px;
  padding: 4px 0px;
  text-align: center;
  margin: 0 auto;
  font-size: 12px;
}
.phoneModule1{
  width: 160px;
  margin: 10px auto;
}
.module1{
  width: 100%;
  box-shadow: 0 0.5em 1em -0.125em #0a0a0a1a, 0 0 0 1px #0a0a0a05;
  padding: 20px 30px;
  box-sizing: border-box;
}
.headModule1{
  display: flex;
  justify-content: space-around;
  height: 50px;
  border-radius: 10px;
  background-color: #f8f7f7;
  padding: 10px 15px;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/view/countryList.vue